const themeImageSource = (image, variant, isDark) => {
  if (!image) return undefined;

  const darkVariant = variant === 'full' ? 'fullDark' : 'previewDark';
  const themedSource = isDark ? image[darkVariant] : image[variant];

  return themedSource || image[variant] || image.preview || image.full;
};

export default themeImageSource;
